import styled from '@emotion/styled';
import React from 'react';

import { color, mediaQueries } from 'src/shared/styles/variables';

import { ThumbIcon } from '../svg/ThumbIcon';

interface Props {
    onClick?: () => void;
    highlighted?: boolean;
    isDown?: boolean;
}

const ThumbButtonWrapper = styled.div<Props>(({ isDown }) => ({
    display: 'flex',
    justifyContent: 'space-around',
    width: '50%',
    height: '1.5rem',
    cursor: 'pointer',
    transform: isDown ? 'rotate(180deg)' : 'none',
    [mediaQueries.xs]: {
        height: '1.25rem',
    },
}));

export const ThumbButton: React.SFC<Props> = props => {
    let thumbColor = color.baliHai;

    if (props.highlighted) {
        thumbColor = props.isDown ? color.sunsetOrange : color.blueLagoon;
    }

    return (
        <ThumbButtonWrapper onClick={props.onClick} {...props}>
            <ThumbIcon color={thumbColor} />
        </ThumbButtonWrapper>
    );
};
